import { render } from "./PolicyView.vue?vue&type=template&id=40b9cf5f&scoped=true"
import script from "./PolicyView.vue?vue&type=script&lang=js"
export * from "./PolicyView.vue?vue&type=script&lang=js"

import "./PolicyView.vue?vue&type=style&index=0&id=40b9cf5f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b9cf5f"]])

export default __exports__